import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=1a1adea8&scoped=true"
import script from "./TicketForm.vue?vue&type=script&lang=js"
export * from "./TicketForm.vue?vue&type=script&lang=js"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=1a1adea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1adea8",
  null
  
)

export default component.exports